import React from 'react';
import { css } from '@emotion/css';
import Container from 'evcharging/components/Container';
import { Theme } from 'evcharging/app/themes';
import useTheme from 'evcharging/hooks/useTheme';
import software1 from 'evcharging/assets/ev-software/software1.png';
import Responsible from 'evcharging/components/Responsible';
import SoftwareItem, { SoftwareItemProps } from 'evcharging/containers/ev-software/SoftwareItem';
import useI18n from 'evcharging/hooks/useI18n';
import { EV_CONSULTATION_URL } from 'evcharging/app/seo/urls';
import LinkButton from 'evcharging/components/LinkButton';
import Title from 'evcharging/components/Title';
import Spacer from 'evcharging/components/Spacer';
import Paragraph from 'evcharging/components/Paragraph';
import Box from 'evcharging/components/Box';

const StreamlinedCharging = () => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const { t } = useI18n();

  const items: SoftwareItemProps[] = [];
  for (let i = 1; i <= 8; i++) {
    items.push({
      title: t(`software.streamline.item${i}.title`),
      text: t(`software.streamline.item${i}.body`),
      icon: software1,
    });
  }

  return (
    <section className={styles.root}>
      <Container>
        <Spacer value={48} mobile={0} />
        <Responsible fractions={[50, 50]}>
          <Box>
            <Title variant={'h2'}>{t('software.title3')}</Title>
            <Spacer value={16} />
            <LinkButton href={EV_CONSULTATION_URL}>{t('form.lead.button')}</LinkButton>
          </Box>
          <Paragraph color={'middle'} maxWidth={620}>
            {t('software.text3')}
          </Paragraph>
        </Responsible>
        <Spacer value={16} />
        <Responsible fractions={Array(4).fill(24)}>
          {items.slice(0, 4).map((item, index) => (
            <SoftwareItem {...item} key={index} fontSize={18} lineHeight={27} />
          ))}
        </Responsible>
        <Responsible fractions={Array(4).fill(24)}>
          {items.slice(4, 8).map((item, index) => (
            <SoftwareItem {...item} key={index} fontSize={18} lineHeight={27} />
          ))}
        </Responsible>
      </Container>
    </section>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    background-color: #f6f8f9;
    background-size: cover;
    padding-top: 24px;
    padding-bottom: 98px;
    ${theme.breakpoints.mobile.down} {
      padding-bottom: 0;
    }
  `,
  title: css`
    padding-top: 28px;
    font-weight: 700;
    font-size: 48px;
    line-height: 60px;
    color: #252c32;
    text-align: center;
    ${theme.breakpoints.mobile.down} {
      font-size: 32px;
      line-height: 40px;
    }
  `,
});

export default StreamlinedCharging;
